import createAxios from 'config/axios'

const getMaritalStatusOptions = () => createAxios.get('/resources/v2/marital-status')

export default getMaritalStatusOptions
